<template>
  <div class="game-container">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    ></tr-box>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
      v-html="item.text"
    ></div>
    <div class="crossword-overflov-container" :style="getStyle(startGameConfig)">
      <div class="overflov-element">
        <table class="crossword">
          <tr v-for="(row, i) in diagram" :key="'row_' + i">
            <td :class="[{ null: !isNull(diagram[i][0].correct) }, { num: !isNull(diagram[i][0].correct) }]">
              <span v-if="!isNull(diagram[i][0].correct) && !hideRowNumber">{{ i + 1 }}.</span>
            </td>
            <td
              v-for="(col, j) in row"
              :key="'col_' + j"
              :class="[
                { null: isNull(diagram[i][j].correct) },
                { num: isNum(i, j) },
                { answer: isStatic(diagram[i][j]) },
                { pass: isPass(i, j) },
                { answerGood: isGood(diagram[i][j]) },
                { answerBad: isWrong(diagram[i][j]) },
              ]"
              :style="[
                {
                  'background-color': isPass(i, j)
                    ? passColor
                    : 'white' && diagram[i][j].static && diagram[i][j].static.color,
                },
                getPassStyle(diagram[i][j], j),
              ]"
            >
              <span v-if="isNum(i, j) && !hideRowNumber">{{ i + 1 }}.</span>
              <div
                v-else-if="isStatic(diagram[i][j])"
                class="answerStatic"
                :style="{ 'background-color': diagram[i][j].static.color }"
                :id="diagram[i][j].id"
                :ref="diagram[i][j].id"
              >
                {{ diagram[i][j].correct[0] }}
              </div>
              <tr-input
                v-else-if="!isNull(diagram[i][j].correct)"
                :key="diagram[i][j].id"
                :ref="diagram[i][j].id"
                :config="diagram[i][j]"
                :tr-input-value="diagram[i][j]"
                @keyArrowLeft="moveLeft"
                @keyArrowRight="moveRight"
                @keyArrowUp="moveUp"
                @keyArrowDown="moveDown"
                @changeElement="autoMove"
                :max-length="1"
                :input-width="startGameConfig.inputWidth"
                :input-height="startGameConfig.inputHeight"
              ></tr-input>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="listPasss" :style="getListPasssStyle(startGameConfig.sharedBlock)">
      <div
        v-if="startGameConfig.sharedBlock && startGameConfig.sharedBlock.txt"
        class="list-pass-element-container"
        :style="{
          position: startGameConfig.sharedBlock.pos !== undefined ? 'absolute' : false,
          top:
            startGameConfig.sharedBlock.pos !== undefined && startGameConfig.sharedBlock.pos.y !== undefined
              ? startGameConfig.sharedBlock.pos.y
              : false,
          left:
            startGameConfig.sharedBlock.pos !== undefined && startGameConfig.sharedBlock.pos.x !== undefined
              ? startGameConfig.sharedBlock.pos.x
              : false,
        }"
      >
        <p v-if="startGameConfig.sharedBlock.title !== undefined" v-html="startGameConfig.sharedBlock.title"></p>
        <span
          v-for="(item, i) in shuffle(startGameConfig.sharedBlock.txt, startGameConfig.sharedBlock.shuffle)"
          :key="'item_' + i"
          v-html="item"
        ></span>
      </div>
      <ol
        class="passList"
        v-if="isList(startGameConfig) && !startGameConfig.posAbsolute"
        :style="getPasssListStyle(startGameConfig.sharedBlock)"
      >
        <p v-if="isTitle(startGameConfig)">
          {{ startGameConfig.sharedBlock.title }}
        </p>
        <li
          v-for="(item, i) in initData"
          :key="'item_' + i"
          :style="getTextInPasssListStyle(startGameConfig.sharedBlock)"
        >
          <mb-audio
            v-if="item.audioSrc"
            :item-audio="{ audioSrc: item.audioSrc, position: 'relative', audioCss: item.audioCss }"
          >
          </mb-audio>
          <!-- <span v-if="item.txt !== undefined" v-html="item.txt"></span> -->
          <!-- <tr-static-text :static-text="item.txt" class="text-element" :style="getStaticTextStyle(item)">
          </tr-static-text> -->
          <tr-text
            :text="elm.value"
            :type="elm.katex"
            v-for="(elm, index) in parseText(item.txt)"
            :key="`pass-list${index}`"
          >
          </tr-text>
          <div v-if="item.src !== undefined" :style="getPasstImageStyle(item)"></div>
        </li>
      </ol>
      <div
        class="passList"
        v-if="!isList(startGameConfig) && !startGameConfig.posAbsolute"
        :style="getPasssListStyle(startGameConfig.sharedBlock)"
      >
        <p v-if="isTitle(startGameConfig)">
          {{ startGameConfig.sharedBlock.title }}
        </p>
        <div
          v-for="(item, i) in processData"
          :key="'item_' + i"
          :style="getTextInPasssListStyle(startGameConfig.sharedBlock)"
        >
          <!-- <span v-if="item.txt !== undefined" v-html="item.txt"></span> -->
          <mb-audio
            v-if="item.audioSrc"
            :item-audio="{ audioSrc: item.audioSrc, position: 'relative', audioCss: item.audioCss }"
          >
          </mb-audio>
          <tr-text
            :text="elem.value"
            :type="elem.katex"
            v-for="(elem, index) in parseText(item.txt)"
            :key="`pass-list${index}`"
          >
          </tr-text>
          <div v-if="item.src !== undefined" :style="getPasstImageStyle(item)"></div>
        </div>
      </div>
    </div>
    <div
      v-for="(item, i) in initDataFiltered"
      :key="'item_' + i"
      :style="{
        display: 'flex',
        position: item.pos !== undefined ? 'absolute' : false,
        top: item.pos !== undefined && item.pos.y !== undefined ? item.pos.y : false,
        left: item.pos !== undefined && item.pos.x !== undefined ? item.pos.x : false,
      }"
    >
      <!-- <span v-if="item.txt !== undefined" v-html="item.txt"></span> -->
      <!-- <tr-static-text :static-text="item.txt" class="text-element" :style="getStaticTextStyle(item)"> </tr-static-text> -->
      <tr-text
        :text="elem.value"
        :type="elem.katex"
        v-for="(elem, index) in parseText(item.txt)"
        :key="`pass-list${index}`"
      >
      </tr-text>

      <div v-if="item.src !== undefined" :style="getPasstImageStyle(item)"></div>
    </div>
  </div>
</template>

<script>
/**
 * @namespace Crossword
 */
import _ from 'lodash';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
import * as utils from '../../Utils/inputUtils';
// import TrStaticText from '../TrInput/TrStaticText';
import TrText from '../TrInput/TrText';
import TrInput from '../TrInput/TrInput';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
import defaultMixin from '../../mixins/defaultMixin';
export default {
  name: 'mp-crossword',
  components: {
    // TrStaticText,
    TrText,
    TrInput,
    TrBox,
    MbAudio,
  },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      imageData: {},
      staticText: [],
      diagram: [],
      passColor: this.startGameConfig.passColor || '#03a9f4',
      /**
       * @memberof Crossword
       * @type {Array} list of words in box
       */
      words: [],
      /**
       * @memberof Crossword
       * @type {Object} value for box config if not present default value are set
       */
      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
        wordConfig: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.wordConfig) || {},
      },
    };
  },
  beforeMount() {
    this.initGame();
  },
  mounted() {},
  methods: {
    setTrInputStyle() {
      let style = {};
      style.backgroundColor = 'red';
      return style;
    },
    shuffle(items, activate) {
      if (items.length == 0) {
        return;
      }
      return activate ? _.shuffle(items) : items;
    },
    initGame() {
      this.initData = {};
      this.initData = this.startGameConfig.crossword;
      this.diagram = [];
      let staticText = [];
      if (this.startGameConfig.imageData) {
        this.imageData = this.startGameConfig.imageData;
      } else if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      }
      var self = this;
      var count = 0;
      let wordList;
      let replaceList;
      this.initData.forEach(function (item, i) {
        if (!item.replace) {
          item.replace = [];
        }
        if (!_.isArray(item.replace)) {
          item.replace = _.map([1], () => {
            return item.replace;
          });
        }
        if (!_.isArray(item.pass)) {
          item.pass = [item.pass];
        }
        wordList = _.map(item.pass, (password) => {
          return password.split('');
        });
        replaceList = _.map(item.replace, (o) => {
          return o.split('');
        });
        self.$set(self.diagram, i, []);
        for (let j = 0; j < item.indx; j++) {
          self.$set(self.diagram[i], j, { correct: null });
        }
        if (wordList[0]) {
          for (let j = item.indx; j < wordList[0].length + item.indx; j++) {
            let staticIndex = _.findIndex(item.static, (o) => {
              return o.index == j - item.indx;
            });
            self.$set(self.diagram[i], j, {
              id: i + '-' + j,
              correct: _.map(wordList, (word) => {
                if (word[j - item.indx]) {
                  return word[j - item.indx];
                }
              }),
              replace: _.map(replaceList, (word) => {
                if (word[j - item.indx]) {
                  return word[j - item.indx];
                }
              }),
              wrong: false,
              static:
                item.static !== undefined && staticIndex != -1
                  ? { color: item.static[staticIndex].color || '' }
                  : false,
              val: '',
              block: false,
              inputStatus: null,
              sel: item.sel,
              indx: item.indx,
              cssStyle: item.cssStyle || null,
            });
          }
        }
        if (self.diagram[i].length > count) count = self.diagram[i].length;
      });

      /**
       * Apply box
       * @namespace Crossword
       * @method if
       * @param  {Array} this.startGameConfig.words list of words in box
       * @return {Boolean}
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.items, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
        console.log('this.words', this.words);
      }
      /** add static text */
      if (this.startGameConfig.staticText) {
        if (
          this.startGameConfig.staticText[0] &&
          this.startGameConfig.staticText[0].items &&
          this.startGameConfig.staticText[0].items.length > 0
        ) {
          if (this.startGameConfig.staticText[0].pick) {
            staticText = _.map(this.startGameConfig.staticText, (elem) => {
              return _.take(_.cloneDeep(elem.items), elem.pick);
            });
            this.staticText.text;
            staticText = _.flatten(staticText);
            // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
          }
        }
        staticText = this.startGameConfig.staticText;
      }

      this.staticText = _.map(staticText, (item, index) => {
        if (this.startGameConfig.layoutStaticText) {
          return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
        } else {
          return item;
        }
      });
    },
    newGame() {
      for (let i = 0; i < this.diagram.length; i++) {
        for (let j = 0; j < this.diagram[i].length; j++) {
          if (this.diagram[i][j].val != null) {
            this.$set(this.diagram[i][j], 'block', false);
            this.$set(this.diagram[i][j], 'val', '');
            if (this.diagram[i][j].obj) {
              this.diagram[i][j].obj.inputsVal('');
            }
          }
        }
      }
      if (this.password !== undefined) {
        for (let i = 0; i < this.password.length; i++) {
          this.$set(this.password[i], 'block', false);
          this.$set(this.password[i], 'val', '');
          if (this.password[i].obj) {
            this.password[i].obj.inputsVal('');
          }
        }
      }
    },
    isNull(a) {
      return a == null;
    },
    isPass(i, j) {
      let pass = false;
      if (this.initData && this.initData[i] && _.isArray(this.initData[i].sel)) {
        _.each(this.initData[i].sel, (item) => {
          if (this.initData[i].indx + item == j) {
            pass = true;
          }
        });
        return pass;
      }
      return this.initData[i].indx + this.initData[i].sel == j;
    },
    isNum(i, j) {
      return (
        this.diagram[i][j].correct == null &&
        this.diagram[i][j + 1] !== undefined &&
        (this.diagram[i][j + 1].correct !== null || this.isPass(i, j + 1) == true)
      );
    },
    isList(item) {
      if (item && item.sharedBlock && item.sharedBlock.listStyle && item.sharedBlock.listStyle.unordered) {
        return !item.sharedBlock.listStyle.unordered;
      }
      return true;
    },
    autoMove($event, payload) {
      let focusElement = this.splitIdPosition(payload, 'right');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'right', i);
      }
      this.moveCursor(focusElement);
    },
    moveCursor(focusElement) {
      if (this.$refs[focusElement]) {
        this.$refs[focusElement][0].$el.querySelector('input').select();
      }
    },
    testNextPossibleCell(focusElement) {
      if (_.isString(focusElement)) {
        if (this.$refs[focusElement] && this.$refs[focusElement][0] && this.$refs[focusElement][0].config) {
          return this.$refs[focusElement][0].config.block;
        } else if (
          this.$refs[focusElement] &&
          this.$refs[focusElement][0] &&
          this.$refs[focusElement][0].className === 'answerStatic'
        ) {
          return true;
        }
      }
      return false;
    },
    splitIdPosition(idString, type = 'current', range = 1) {
      let focusElement = idString.split('-');
      if (focusElement.length === 2) {
        focusElement = _.map(focusElement, (item, index) => {
          switch (type) {
            case 'left':
              if (index === 1) {
                return parseInt(item) - parseInt(range);
              }
              return parseInt(item);
              break;
            case 'right':
              if (index === 1) {
                return parseInt(item) + parseInt(range);
              }
              return parseInt(item);
              break;
            case 'up':
              if (index === 0) {
                return parseInt(item) - parseInt(range);
              }
              return parseInt(item);
              break;
            case 'down':
              if (index === 0) {
                return parseInt(item) + parseInt(range);
              }
              return parseInt(item);
              break;
            case 'current':
              if (index === 0) {
                return parseInt(item);
              }
              return parseInt(item);
              break;
          }
        });
      } else if (focusElement.length === 3) {
        focusElement = _.map(focusElement, (item, index) => {
          switch (type) {
            case 'left':
              if (index === 1) {
                return parseInt(item) - parseInt(range);
              }
              return item;
              break;
            case 'right':
              if (index === 1) {
                return parseInt(item) + parseInt(range);
              }
              return item;
              break;
            case 'up':
              if (index === 0) {
                return parseInt(item) - parseInt(range);
              }
              return item;
              break;
            case 'down':
              if (index === 0) {
                return parseInt(item) + parseInt(range);
              }
              return item;
              break;
          }
        });
      }
      focusElement = focusElement.join('-');
      return focusElement;
    },
    moveLeft(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'left');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'left', i);
      }
      this.moveCursor(focusElement);
    },
    moveRight(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'right');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'right', i);
      }
      this.moveCursor(focusElement);
    },
    moveUp(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'up');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'up', i);
      }
      this.moveCursor(focusElement);
    },
    moveDown(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'down');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'down', i);
      }
      this.moveCursor(focusElement);
    },
    resetGameAction() {
      let diagram = this.diagram;
      _.each(diagram, (row, rowIndex) => {
        _.each(row, (col, colIndex) => {
          this.diagram[rowIndex][colIndex].block = false;
        });
      });
      this.initGame();
      this.resetCheckStatus();
    },
    checkGameAction() {
      var isCorrect = true;
      var isCorrectWord = true;
      let index;
      let self = this;
      this.diagram.forEach(function (item, i) {
        isCorrectWord = true;
        item.forEach(function (obj, j) {
          if (obj.correct != null) {
            index = _.findIndex(obj.correct, (o) => {
              if (self.startGameConfig.caseSensitive) {
                return o === _.trim(obj.val);
              } else {
                return _.trim(o.toUpperCase()) === _.trim(obj.val.toUpperCase());
              }
            });
            if (index === -1 && !_.isObject(obj.static)) {
              isCorrectWord = isCorrect = false;
            }
          }
        });
        /**  całe słowo w wierszu
         * @type {String}
         * @memberof Crossword
         *
         */
        let wholeWord = _.compact(
          _.map(item, (cell) => {
            if (cell.correct != null) {
              /** zwraca albo wartośc z inputta (val) albo jeśli jest static PIERWSZĄ!! z listy możliwych odpowiedzi  */
              return _.isObject(cell.static) && cell.correct && cell.correct[0] ? cell.correct[0] : cell.val;
            }
          })
        ).join('');
        let wordTest;
        /** testuje czy cały wyraz jest poprawny (mozliwe odpowiedzi z tablicy pass) */
        if (self.initData[i] && self.initData[i].pass) {
          wordTest = _.findIndex(self.initData[i].pass, (password) => {
            if (self.startGameConfig.caseSensitive) {
              return password === wholeWord;
            } else {
              return password.toUpperCase() === wholeWord.toUpperCase();
            }
          });
        }
        /** jeśli cały wyraz źle mimo że poszczególne litery OK ustaw na ŹLE */
        if (wordTest === -1) {
          isCorrectWord = isCorrect = false;
          item.forEach(function (obj, j) {
            if (obj.correct != null) {
              self.diagram[i][j].wrong = true;
            }
          });
        }
        if (isCorrectWord) {
          item.forEach(function (obj, j) {
            if (obj.correct != null) {
              self.diagram[i][j].block = true;
              if (!_.isEmpty(obj.replace)) {
                let replaceIndex = -1;
                if (self.startGameConfig.caseSensitive) {
                  replaceIndex = _.indexOf(obj.correct, obj.val);
                } else {
                  let correctUpperCase = _.map(obj.correct, (char) => {
                    return char.toUpperCase();
                  });
                  replaceIndex = _.indexOf(correctUpperCase, obj.val.toUpperCase());
                }
                if (replaceIndex != -1) {
                  self.$set(self.diagram[i][j], 'val', obj.replace[replaceIndex]);
                }
              }
            }
          });
        } else {
          item.forEach(function (obj, j) {
            if (obj.correct != null && !obj.pass) {
              self.diagram[i][j].wrong = true;
            }
          });
        }
      });
      if (!isCorrect) {
        setTimeout(this.removeWrong, 1000);
      }
      return isCorrect;
    },
    removeWrong() {
      var self = this;
      self.diagram.forEach(function (x) {
        x.forEach(function (y) {
          if (y.wrong === true) y.wrong = false;
        });
      });
    },
    /**
     * test if object objectExist
     * @memberof Crossword
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getPasstImageStyle(data) {
      let item = _.cloneDeep(data);
      return this.getImageStyle(
        _.merge(item, {
          cssStyle: {
            'background-size': 'cover',
          },
          pos: { x: '42px', y: 0 },
          imagePath: item.src,
          width: this.startGameConfig.imgW !== undefined ? this.startGameConfig.imgW : 'auto',
          height: this.startGameConfig.imgH !== undefined ? this.startGameConfig.imgH : 'auto',
        })
      );
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      } else {
        return '';
      }
      return _.merge({ position: 'absolute' }, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    getStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getPassStyle(item, index) {
      if (item.sel + item.indx === index) {
        return _.merge({}, this.getCustomStyle(item));
      } else {
        return {};
      }
    },
    getListPasssStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getPasssListStyle(item) {
      if (item && item.listStyle) {
        return _.merge(
          {},
          {
            position:
              this.startGameConfig.passList !== undefined && this.startGameConfig.passList.pos !== undefined
                ? 'absolute'
                : undefined,
            left:
              this.startGameConfig.passList !== undefined &&
              this.startGameConfig.passList.pos !== undefined &&
              Number.isInteger(this.startGameConfig.passList.pos.x)
                ? this.startGameConfig.passList.pos.x + 'px'
                : undefined,
            top:
              this.startGameConfig.passList !== undefined &&
              this.startGameConfig.passList.pos !== undefined &&
              Number.isInteger(this.startGameConfig.passList.pos.y)
                ? startGameConfig.passList.pos.y + 'px'
                : undefined,
          },
          this.getCustomStyle(item.listStyle)
        );
      }
    },
    getTextInPasssListStyle(item) {
      if (item && item.listStyle && item.listStyle.textStyle) {
        return _.merge(
          {},
          {
            position:
              this.startGameConfig.passList !== undefined && this.startGameConfig.passList.pos !== undefined
                ? 'absolute'
                : undefined,
            left:
              this.startGameConfig.passList !== undefined &&
              this.startGameConfig.passList.pos !== undefined &&
              Number.isInteger(this.startGameConfig.passList.pos.x)
                ? this.startGameConfig.passList.pos.x + 'px'
                : undefined,
            top:
              this.startGameConfig.passList !== undefined &&
              this.startGameConfig.passList.pos !== undefined &&
              Number.isInteger(this.startGameConfig.passList.pos.y)
                ? startGameConfig.passList.pos.y + 'px'
                : undefined,
          },
          this.getCustomStyle(item.listStyle.textStyle)
        );
      }
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        // 'position': 'absolute',
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        // 'position': 'absolute',
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    isTitle(item) {
      if (item && item.sharedBlock && item.sharedBlock.title) {
        return true;
      }
      return false;
    },
    isWrong(a) {
      return a.wrong == true;
    },
    isGood(a) {
      return a.block === true && a.static !== true && this.initData.showGood !== false;
    },
    isStatic(a) {
      return _.isObject(a.static);
    },
    /** Function added only for compatibility with hack in textBlock type components */
    removeUnnecessarySlash(string) {
      const search = '\\\\';
      const replaceWith = '\\';
      const result = string.split(search).join(replaceWith);
      return result;
      // return _.replace(string, '\\\\', '\\');
    },
    parseKatex(string) {
      let parsed = [];
      let split = string.split(/(_#.*?#_)/g);
      if (split) {
        // for (const item of split) {
        parsed = split.map((item) => {
          let katexFlag = false;
          let match = item.match(/_#(.*?)#_/g);
          if (match) {
            katexFlag = true;
            item = item.substring(2, item.length - 2);
            item = this.removeUnnecessarySlash(item);
          }
          return { katex: katexFlag, value: item };
        });
        // }
      }
      return parsed;
    },
    parseText(item) {
      return this.parseKatex(item);
    },
  },
  computed: {
    hideRowNumber() {
      if (this.startGameConfig.sharedBlock) {
        return this.startGameConfig.sharedBlock.hideRowNumber;
      }
      return false;
    },
    processData() {
      if (
        this.initData &&
        this.startGameConfig.sharedBlock &&
        this.startGameConfig.sharedBlock.listStyle &&
        this.startGameConfig.sharedBlock.listStyle.shuffle
      ) {
        return _.shuffle(this.initData);
      }
      return this.initData;
    },
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
    initDataFiltered() {
      return _.filter(this.initData, () => {
        return this.startGameConfig.posAbsolute === true && this.startGameConfig.sharedBlock === undefined;
      });
    },
  },
};
</script>
<style lang="scss">
.crossword {
  .game-tr-input {
    background-color: transparent !important;
    .inline-input {
      background-color: transparent !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  // margin-top:100px;
  // padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  padding-top: 100px;
  .crossword-overflov-container {
    position: relative;
    top: 43px;
    /* left: 100px; */
    height: 76%;
    width: 100%;
    display: flex;
    justify-content: center;
    /* align-items: baseline; */
    /* flex-direction: column; */
    overflow: auto;
    padding-top: 10px;
    .overflov-element {
      height: 100%;
    }
  }
}

.listPasss {
  display: flex;
  flex-direction: inherit;
  padding-top: 20px;
  position: absolute;
  top: 650px;
  .list-pass-element-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

.passList {
  text-align: left;
  margin-top: 5px;
  overflow: auto;
  height: 100%;
  padding-left: 60px;
}

.game-container table {
  border-collapse: collapse;
  font-weight: bold;
}

.game-container td {
  // border: 1px solid black;
  // box-shadow: inset 0 0 2px 3px black;
  vertical-align: central;
  text-align: center;
}
.game-container td :not(.null) {
  // box-shadow: rgb(56, 56, 56) 0 0 3px 3px;
  box-shadow: rgb(56, 56, 56) 0 0 0 2px;
  vertical-align: central;
  text-align: center;
}

.crossword .num {
  border: none;
  width: 52px;
  font-size: 32px;
  //    padding: 0 25px;
  box-shadow: none !important;
}

.num span {
  box-shadow: none !important;
}

.crossword .null {
  border: none;
}
.crossword .pass {
  background-color: #03a9f4;
}
.answer {
  transition: all 500ms ease 0s;
}
.answerBad:not(.pass) {
  background: rgba(196, 26, 26, 0.1) !important;
}
.answerGood:not(.pass) {
  background-color: rgba(55, 178, 228, 0.45) !important;
}
.crossword .answer.pass {
  background-color: #03a9f4;
}
// .td-answer-static {
//     background-color: #74ff9b;
//
// }
.answerStatic {
  background-color: '#e6e6e6';
  box-shadow: #383838 0 0 0 2px, inset 0 0 10px 0 #b3b3b3 !important;
  height: 51px;
  width: 50px;
  line-height: 1.2 !important;
}
.main-image-container {
  position: relative;
  display: block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
